import React from 'react';
import { connect } from 'react-redux';
import { saveStates } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { toggleDatasetPreview } from '../actions';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { disableDatasetToggleView } from '../status/helper';
import { datasetSettingsFields } from '../settings/state/state';
import { datasetSourceAndStepAttributes } from '../state/state';

const ViewDatasetAction = ({
  category,
  code,
  disabled,
  preview,
  toggleSummary,
}) => (
  <RibbonMenu
    name="view"
    icon={preview ? 'file outline' : 'file'}
    message={preview ? 'actions.preview' : 'actions.curate'}
    onClick={() => toggleSummary(category, code)}
    className="aridhia-view-dataset-action"
    disabled={disabled}
  />
);

const mapStateToProps = ({
  datasets: { datasets },
  catalogues: { templates },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    asViewer: { on: false },
    settings: datasetSettingsFields(),
    steps: datasetSourceAndStepAttributes(),
    ...saveStates,
  });

  return {
    disabled: disableDatasetToggleView(dataset, template),
    preview: !dataset.asViewer.on,
  };
};

const mapDispatchToProps = {
  toggleSummary: toggleDatasetPreview,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewDatasetAction);
